// eslint-disable-next-line no-restricted-imports
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RivalsAppProps, RivalsPageProps } from "rivals/Context";
import SignUp from "rivals/components/pages/Registration/SignUp/container";
import { isAuthenticated } from "rivals/redux//authentication/selectors";
import { getRailsConstants as getRailsConstantsAction } from "rivals/redux/rails/actions";
import { RailsConstantsKeys } from "rivals/redux/rails/reducer";
import { PATHS } from "rivals/shared/constants";
import { redirectToOn3TransitionPage } from "rivals/shared/utils/redirects";
import styles from "./SignUp.module.scss";

const COMPONENTS = [RailsConstantsKeys.SUBSCRIPTION_PRICING];

function SignUpPage(): JSX.Element {
  const router = useRouter();
  const authenticated = useSelector(isAuthenticated);

  useEffect(() => {
    if (authenticated) {
      router.push(PATHS.SUBSCRIPTIONS);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ cat: "rvlpreg", type: "rvls" });
    }
  }, [authenticated, router]);

  return (
    <main className={styles.wrapper} role="main">
      <SignUp />
    </main>
  );
}

SignUpPage.getInitialProps = async ({
  flipperSettings,
  isServer,
  store: { dispatch },
  res
}: RivalsAppProps): Promise<RivalsPageProps> => {
  if (flipperSettings?.disableSubscriptions) {
    redirectToOn3TransitionPage(res);
    return { isServer };
  }

  dispatch(getRailsConstantsAction(COMPONENTS));

  return { isServer };
};

export default SignUpPage;
